import React from 'react';
import './serverError.css';
import ServerDown from '../Asset/Images/error503.svg';
import strings from '../utils/property-file/serverError.json'
import Ripple from '../component/button/ripple';
import { useNavigate } from 'react-router-dom';
import constants from "../utils/constants";
import { useEffect } from 'react';

export default function ServerError() {
    const nav = useNavigate();
    useEffect(() => {
        let status = localStorage.getItem('status')
        if (!status) {
            nav(constants.navigationLink.loginLink)
        }
    }, [])
    return (
        <div className="server-down-page">
            <div className="animation-effet-on-server-error">
                <div className='white-filter-on-server-error'></div>
                <img src={ServerDown} alt="" className='image-server-down' />
            </div>
            <div className="server-down-heading">
                <h1>{strings.serverHeading}</h1>
            </div>
            <div className='server-statement-container'>
                <p>{strings.serverStatement}</p>
                <ol>
                    <li>{strings.serverStatement2}</li>
                </ol>
                <center>
                    <button
                        type="submit"
                        className="btn btn-primary server-error-btn mt-1"
                        onClick={() => {
                            nav(constants.navigationLink.backPage)
                        }}>
                        <Ripple duration={1000} />
                        {strings['btn-statement']}
                    </button>
                </center>
            </div>
        </div>
    )
}
